// src/pages/Shop.jsx
import React from 'react';
import HeroSection from '../components/Home/HeroBanner';
import ServiceGallery from '../components/Service/SeriveGallery';
import Layout from '../Layout.js/Layout';
import StatsSection from '../components/StatSection';
import GetTouchSection from '../components/HeroSection';
import ClientShowcaseCarousel from '../components/Carrosel';
import CategoryList from '../components/ProductCategoryList';
import WhyChooseUs from '../components/Home/ChooseUs';
import ServiceCategories from '../components/Home/ServiceCategories';
import ProductCategories from '../components/Home/ProductCategories';
import BrandsPartner from '../components/Home/BrandsPartner';
import ShopInfo from '../components/Home/ShopInfo';
import ShopStandards from '../components/Home/ShopStandards';

const Home = () => {
  return (
    <Layout>
      <HeroSection />
      <WhyChooseUs />
      <ServiceCategories />
      <ProductCategories />
      <BrandsPartner />
      <ShopInfo />
      <ShopStandards />
    </Layout>
  );
};

export default Home;
